import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container my-5">
      <>
        <h1>
          <span>Privacy Policy</span>
        </h1>
        <p>Effective Date: 14 May 2025</p>
        <p>
          Company Name: Silverline Logistics Limited (trading as Silverline
          Auto)
        </p>
        <p>Company Number: 10378532</p>
        <p>
          Registered Address: Unit 2, Pool Road Industrial Estate, Nuneaton,
          CV10 9AE
        </p>
        <p>Email: inquiry@silverlineautoltd.co.uk</p>
        <p>Telephone: 07496 360002</p>
        <p>Website: www.silverlineautoltd.co.uk</p>
        <h3 className="western">1. Introduction</h3>
        <p>
          This Privacy Policy explains how Silverline Logistics Limited
          (“Silverline Auto”, “we”, “us”, “our”) collects, uses, stores, and
          protects your personal data in line with the UK General Data
          Protection Regulation (UK GDPR) and the Data Protection Act 2018.
          <br /> <br /> By engaging with us online, in person, or over the
          phone, you acknowledge and agree to the data handling practices
          outlined here.
        </p>
        <h3 className="western">2. What is Personal Data?</h3>
        <p>
          Personal data refers to any information that can directly or
          indirectly identify you. This includes identifiers such as your name,
          contact details, and transaction history.
          <br /> <br /> We do not knowingly collect any special category data
          (e.g., health or biometric data) or data relating to criminal
          convictions.
        </p>
        <h3 className="western">3. Data We Collect</h3>
        <p>
          We may collect and process the following types of personal data:
          <br /> - Identity Data: Name, date of birth, driving licence number
          <br /> - Contact Data: Home address, phone number, email
          <br /> - Transaction Data: Vehicle purchase/sale details, invoices
          <br /> - Financial Data: Bank account or payment card information (if
          applicable)
          <br /> - Technical Data: IP address, browser type, cookies, device
          details, location data
          <br /> - Marketing Preferences: Communication preferences and
          opt-in/opt-out status
        </p>
        <h3 className="western">4. How We Collect Your Data</h3>
        <p>
          We collect data through the following channels:
          <br /> - Directly from you during vehicle sales, service enquiries, or
          phone/email interactions
          <br /> - Through our website when you complete forms or request
          information
          <br /> - From finance or warranty providers you engage with (with your
          consent)
          <br /> - Through surveys, promotions, or feedback submissions
        </p>
        <h3 className="western">5. Legal Basis for Processing</h3>
        <p>
          We process your data based on the following lawful grounds under the
          UK GDPR:
          <br /> - Contractual necessity
          <br /> - Legal obligations
          <br /> - Consent
          <br /> - Legitimate interests, including customer service and fraud
          prevention
        </p>
        <h3 className="western">6. Use of Your Personal Data</h3>
        <p>
          Your data is used for:
          <br /> - Managing vehicle sales, purchases, and service contracts
          <br /> - Processing finance and warranty applications
          <br /> - Contacting you regarding appointments, issues, or service
          updates
          <br /> - Marketing communications (with your consent)
          <br /> - Internal audits and operational improvements
        </p>
        <h3 className="western">7. Data Sharing</h3>
        <p>
          We share personal data with trusted third parties:
          <br /> - Finance/warranty providers (with consent)
          <br /> - IT support and service providers
          <br /> - Payment processors
          <br /> - Legal/regulatory authorities when required
          <br /> We do not sell or lease your data to third parties.
        </p>
        <h3 className="western">8. Data Retention</h3>
        <p>
          We retain data for up to 7 years following your last transaction
          unless a longer period is required by law.
        </p>
        <h3 className="western">9. Data Security</h3>
        <p>
          We employ industry-standard measures including:
          <br /> - Secure servers and firewalls
          <br /> - Encrypted payment systems
          <br /> - Role-based access controls
          <br /> - Regular data backups and security audits
        </p>
        <h3 className="western">10. Your Rights</h3>
        <p>
          Under UK GDPR, you have rights to:
          <br /> - Access your data
          <br /> - Request correction or deletion
          <br /> - Restrict or object to processing
          <br /> - Data portability
          <br /> - Withdraw consent
          <br /> - Lodge a complaint with the ICO
        </p>
        <h3 className="western">11. Cookies and Tracking</h3>
        <p>
          Our website uses cookies for functionality and analytics. You can
          configure your browser to block cookies. See our separate Cookie
          Policy for more details.
        </p>
        <h3 className="western">12. Marketing</h3>
        <p>
          We will only contact you for marketing purposes if you opt in. You can
          unsubscribe at any time via links in our communications or by
          contacting us.
        </p>
        <h3 className="western">13. Financial Data &amp; FCA Compliance</h3>
        <p>
          Financial data shared with third parties is done securely and only
          with your permission. We comply with FCA requirements and do not
          engage in automated decision-making without your explicit consent.
        </p>
        <h3 className="western">14. International Transfers</h3>
        <p>
          All data is stored in the UK. If data is transferred outside the UK,
          we ensure suitable safeguards such as Standard Contractual Clauses.
        </p>
        <h3 className="western">15. Liability</h3>
        <p>
          We are not liable for data breaches arising from external attacks,
          third-party platforms, or user negligence. Users must protect their
          login credentials.
        </p>
        <h3 className="western">16. Contact</h3>
        <p>
          If you have queries, contact:
          <br /> Data Protection Officer
          <br /> Silverline Auto
          <br /> Unit 2, Pool Road Industrial Estate, Nuneaton, CV10 9AE
          <br /> Email: inquiry@silverlineautoltd.co.uk
          <br /> Phone: 07496 360002
        </p>
        <p>
          <br />{" "}
        </p>
        <p>
          <span style={{ color: "#17365d" }}>
            <span style={{ fontFamily: "Calibri, serif" }}>
              <span style={{ fontSize: "x-large" }}>Cookie Policy</span>
            </span>
          </span>
        </p>
        <h3 className="western">Effective Date</h3>
        <p>14 May 2025</p>
        <h3 className="western">1. What Are Cookies?</h3>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help improve your browsing experience by remembering
          preferences and usage patterns.
        </p>
        <h3 className="western">2. Types of Cookies We Use</h3>
        <p>
          - Essential Cookies: Required for basic website functions
          <br /> - Performance Cookies: Help us understand website usage (e.g.,
          via Google Analytics)
          <br /> - Functional Cookies: Remember user preferences
          <br /> - Marketing Cookies: Used with your consent to provide tailored
          ads
        </p>
        <h3 className="western">3. Managing Cookies</h3>
        <p>
          You can control cookies via your browser settings. Most browsers allow
          you to block or delete cookies. However, disabling certain cookies may
          affect your website experience.
        </p>
        <h3 className="western">4. Third-Party Cookies</h3>
        <p>
          We may allow third-party services (e.g., analytics providers) to set
          cookies to analyse website usage. These providers are bound by their
          own privacy policies.
        </p>
        <h3 className="western">5. Changes to This Policy</h3>
        <p>
          We may update this Cookie Policy from time to time. Changes will be
          posted on this page with an updated effective date.
        </p>
        <h3 className="western">6. Contact</h3>
        <p>
          For questions about our use of cookies, contact us at
          inquiry@silverlineautoltd.co.uk or call 07496 360002.
        </p>
      </>
    </div>
  );
};

export default PrivacyPolicy;
